<template>
    <div>
        <!-- 兑换确认弹窗 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="confirmShow" @click-overlay="cancelExchange" :close-on-click-overlay="false">
            <div class="popup-center">
                <img class="confirm-popup" src="../../../assets/images/postalNewCustomer/turntable/popup_confirm.png" alt="">
                <div class="confirm-box flex-column-center">
                    <div class="box-item">是否使用<span class="blue">2000kcal</span>精力值</div>
                    <div class="box-item">兑换<span class="green">1次</span>抽奖机会？</div>
                </div>
                <div class="button flex-row-center">
                    <div class="btn-item right" @click="cancelExchange"></div>
                    <div class="btn-item" @click="confirmExchange"></div>
                </div>
            </div>
        </van-popup>

        <!-- 抽奖提示弹窗 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="tipShow" @click-overlay="closeTip" :close-on-click-overlay="false">
            <div class="popup-center">
                <img class="confirm-popup" src="../../../assets/images/postalNewCustomer/turntable/popup_tips.png" alt="">
                <div class="confirm-box flex-column-center">
                    <div class="box-item center">您需要先报名才能参与<br>活动抽奖哦</div>
                </div>
                <div class="button flex-row-center">
                    <div class="btn-item right" @click="closeTip"></div>
                    <div class="btn-item" @click="toSignUp"></div>
                </div>
            </div>
        </van-popup>

        <!-- 活动结束弹窗 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="activeEndShow" @click-overlay="closeActiveEnd" :close-on-click-overlay="false">
            <div class="popup-center">
                <img class="active-over" src="../../../assets/images/postalNewCustomer/active_over.png" alt="">
                <div class="button flex-row-center">
                    <div class="btn-item know" @click="closeActiveEnd"></div>
                </div>
            </div>
        </van-popup>

        <!-- 首页领奖轮播图 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="showCard" @click-overlay="closeSwiper('close')" :close-on-click-overlay="false">
            <div class="swiper-box">
                <van-swipe :loop="false" indicator-color="#FF5348" :show-indicators="false" @change="onChange">
                    <van-swipe-item v-for="(item,index) in cardArray" :key="index">
                        <div class="flex-row-center">
                            <img class="card" :class="{'turn-table':item.type == 'turntable'}" :src="item.src">
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="custom-indicator flex-row-center" v-if="cardArray.length > 1">
                    <div class="indicator" v-for="(item,index) in cardArray" :key="index" :class="{'common':index != current, 'active':index == current}"></div>
                </div>
                <div class="flex-row-center">
                    <img class="bag-button" @click="closeSwiper('change')" src="../../../assets/images/postalNewCustomer/turntable/popup_btn_get.png">
                </div>
            </div>
        </van-popup>

        <!-- 奖品展示 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="isMetroShow" @click-overlay="closeMetro" :close-on-click-overlay="false">
            <div class="popup-center">
                <div class="reward-box">
                    <img class="reward-img-metro" src="../../../assets/images/postalNewCustomer/popup_reward_metro.png">
                </div>
                <div class="change-box">
                    <div class="reward-remark">*请到青岛地铁APP“优惠券”中查看</div>
                    <img class="reward-btn" @click="closeMetro" src="../../../assets/images/postalNewCustomer/turntable/popup_btn_get.png" alt="">
                </div>
            </div>
        </van-popup>

        <!-- 核销弹窗 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="isWriteOff" @click-overlay="closeWriteOff" :close-on-click-overlay="false">
            <div class="popup-center">
                <img class="write-off-img" src="../../../assets/images/postalNewCustomer/li_da_you_hui_quan.png">
                <div class="write-off-no-input" v-if="couponType == 'writeOff'">
                    <input v-model="writeOffCode" class="write-off-no-input__inner" placeholder="请店员输入核销密码" type="password" />
                </div>
                <div class="change-box" v-if="couponType == 'writeOff'">
                    <div class="reward-remark">*请在付款结账时向店员出示此页面<br>并让店员输入密码进行核销</div>
                    <img class="reward-btn" @click="handleWriteReward" src="../../../assets/images/postalNewCustomer/bottom5.png" alt="">
                </div>
                <div class="change-box" v-else>
                    <img class="reward-btn" @click="closeWriteOff" src="../../../assets/images/postalNewCustomer/turntable/popup_btn_get.png" alt="">
                    <div class="blue" @click="checkRule">查看使用规则</div>
                </div>
            </div>
        </van-popup>

        <!-- 核销成功 -->
        <van-popup style="background:rgba(255,255,255,0);" v-model="writeSuccess" @click-overlay="closeWriteSuccess" :close-on-click-overlay="false">
            <div class="popup-center">
                <img class="write-off-success" src="../../../assets/images/postalNewCustomer/popup7.png" alt="">
                <div class="change-box">
                    <img class="reward-btn" @click="closeWriteSuccess" src="../../../assets/images/postalNewCustomer/confirm-button.png" alt="">
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

export default {
    props: {
        //是否显示兑换弹窗
        confirmShow: {
            type: Boolean,
            default: false
        },
        //是否显示抽奖提示弹窗
        tipShow: {
            type: Boolean,
            default: false
        },
        //是否显示关闭弹窗
        activeEndShow: {
            type: Boolean,
            default: false
        },
        //是否显示奖品
        showCard: {
            type: Boolean,
            default: false
        },
        //红包类型 88 18 8
        bagType: {
            type: [String, Number],
            default: '8'
        },
        //是否为新用户
        isNew: {
            type: Boolean,
            default: false
        },
        //是否显示地铁券弹窗
        isMetroShow: {
            type: Boolean,
            default: false
        },
        //是否显示利达优惠券弹窗
        isWriteOff: {
            type: Boolean,
            default: false
        },
        //优惠券是否为核销券
        couponType: {
            type: String,
            default: ''
        },
        //是否显示核销成功弹窗
        writeSuccess: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    data() {
        return {
            current: 0,
            writeOffCode: '',
            // isNew: true
        }
    },
    computed: {
        cardArray() {
            let arr = []
            if (this.isNew && this.bagType) {
                arr = [
                    {
                        type: 'bag',
                        src: require(`../../../assets/images/postalNewCustomer/popop_red_${this.bagType}.png`)
                    },
                    {
                        type: 'turntable',
                        src: require('../../../assets/images/postalNewCustomer/drawCount.png')
                    },
                ]
            } else {
                arr = [{
                    type: 'turntable',
                    src: require('../../../assets/images/postalNewCustomer/drawCount.png')
                }]
            }
            return arr
        }
    },
    created() { },
    mounted() {
        // console.log(this.cardArray)
    },
    beforeDestroy() { },
    methods: {
        //关闭地铁券弹窗
        closeMetro() {
            this.$emit('closeMetro')
        },
        //确认兑换
        confirmExchange() {
            this.$emit('confirmExchange')
        },
        //取消兑换
        cancelExchange() {
            this.$emit('cancelExchange')
        },
        //关闭抽奖提示弹窗
        closeTip() {
            this.$emit('closeTip')
        },
        //去报名
        toSignUp() {
            this.$emit('toSignUp')
        },
        //关闭活动结束弹窗
        closeActiveEnd() {
            this.$emit('closeActiveEnd')
        },
        //轮播图切换
        onChange(index) {
            this.current = index;
        },
        //关闭轮播弹窗
        closeSwiper(type) {
            this.$emit('closeSwiper', type)
        },
        //核销
        handleWriteReward() {
            if (!this.writeOffCode) {
                this.$toast('请输入核销密码');
                return;
            }
            this.$emit('handleWriteReward', this.writeOffCode)
        },
        //关闭优惠券弹窗
        closeWriteOff() {
            this.$emit('closeWriteOff')
        },
        //查看使用规则
        checkRule() {
            const prizeId = 'b9b4ecc6-fa81-40fb-8b3a-767a1124c71c'
            this.$router.push({
                name: 'postalRules',
                query: { prizeId }
            })
        },
        //关闭核销成功弹窗
        closeWriteSuccess() {
            this.$emit('closeWriteSuccess')
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.popup-center {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .write-off-img {
        width: pxvw(532);
    }
    .write-off-success {
        width: pxvw(486);
    }
    .write-off-no-input {
        width: 80%;
        height: px2rem(80);
        border-radius: px2rem(40);
        background-color: rgba(0, 0, 0, 0.8);
        margin: px2rem(-40) auto 0;
        border: 2px solid #99977c;
        z-index: 10;
        position: relative;
        box-shadow: inset 0 0 px2rem(30) px2rem(10) #99977c;
        display: flex;
        align-items: center;

        .write-off-no-input__inner {
            height: 100%;
            width: 100%;
            border-radius: px2rem(40);
            background-color: transparent;
            border: none;
            color: #ffffff;
            font-size: px2rem(32);
            text-align: center;
            flex: 1;
        }

        .copy-icon {
            //position: absolute;
            //right: px2rem(30);
            //top: 50%;
            //transform: translateY(-50%);
            width: px2rem(32);
            height: auto;
            margin-right: px2rem(32);
        }
    }
    .tips {
        width: 80%;
        color: #ff4b33;
        font-size: px2rem(20);
        text-align: center;
        margin: px2rem(24) auto;
    }

    .submit-btn {
        width: 60%;
        height: auto;
        display: block;
        margin: 0 auto;
    }
    .reward-box {
        position: relative;
        .reward-img-metro {
            width: pxvw(585);
        }
    }
    .change-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin-top: pxvw(25);
        .reward-remark {
            padding-bottom: pxvw(25);
            color: #ff4b33;
            font-size: pxvw(22);
            text-align: center;
        }
        .reward-btn {
            width: pxvw(429);
        }
        .blue {
            color: #63e4fb;
            font-size: pxvw(24);
            margin-top: pxvw(24);
            text-decoration: underline;
        }
    }
    .confirm-popup {
        width: pxvw(630);
    }
    .active-over {
        width: pxvw(604);
    }
    .confirm-box {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 26vw;
        line-height: 8.67vw;

        .box-item {
            color: #2b3f37;
            font-size: pxvw(33);
            .green {
                color: #14cd84;
            }
            .blue {
                color: #95a2fe;
            }
            .center {
                text-align: center;
            }
        }
    }
    .flex-column-center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .button {
        position: absolute;
        left: 0;
        right: 0;
        bottom: pxvw(70);
        // background: rgba(0, 0, 0, 0.5);
        .btn-item {
            width: pxvw(233);
            height: pxvw(89);
            &.right {
                margin-right: pxvw(15);
            }
            &.know {
                width: pxvw(366);
            }
        }
    }
}
.flex-row-center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.swiper-box {
    width: 100%;
    .card {
        // width: pxvw(418);
        height: pxvw(716);
    }
    .bag-button {
        width: pxvw(414);
        margin-top: pxvw(40);
    }
    .turn-table {
        // width: pxvw(510);
    }
    .custom-indicator {
        padding-top: pxvw(40);
        .indicator {
            width: pxvw(18);
            height: pxvw(18);
            border-radius: pxvw(50);
            margin-right: pxvw(13);
            color: #fff;
            &.common {
                border: pxvw(3) solid white;
            }
            &.active {
                background: white;
            }
        }
    }
}
</style>